import {
  COUNTRY_FILTER,
  STATUS_FILTER,
} from "../../../custom/Utils/ListFilterOptions";

const schema = localStorage.getItem("schema");
export const basicFormData = () => ({
  inputData: {
    country_id: "",
    state_name: "",
    created_by: "",
    updated_by: "",
    is_active: true,
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "state_masters",
    schema: schema,
    include: [
      {
        model: "country_masters",
        as: "country",
      },
    ],
  };

  const navigatePage = { back: "/state-list" };

  const headerName = "State";

  const validationType = "StateCreate";
  const createEndpoint = "/updaterelationaldata  ";
  const updateEndpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";
  const dependentDropdownData = [
    {
      module_name: "state_masters",
      initialPayload: {
        modelName: "state_masters",
        schema: schema,
        whereCondition: { is_child: false },
      },
      isOtherDependentOnThis: false,
      patchFieldName: "state_name",
      dropdownDataValue: "parent_id",
      endPoint: "/getRecords",
    },
  ];
  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
    dependentDropdownData,
  };
};

export const listPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "state_masters",
    schema: schema,
    include: [
      {
        model: "country_masters",
        as: "country",
      },
    ],
    // relations: [
    //   {
    //     module: "user_masters",
    //     moduleAs: "createdBy",
    //   },
    //   {
    //     module: "user_masters",
    //     moduleAs: "updatedBy",
    //   },
    //   {
    //     module: "user_masters",
    //     moduleAs: "updatedBy",
    //   },
    // ],
  };

  const columnData = [
    { label: "sr.no", value: "index" },
    { label: "Country Name", value: "country.country_name" },
    { label: "State Name", value: "state_name" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/state-create",
    edit: "/state-create",
    view: "/state-view",
  };

  const searchfields = ["state_name", "country.country_name"];

  const headerName = "State";
  const endpoint = "/getRecords";
  const exportFileName = "StateData.xlsx";

  const filterConfig = [COUNTRY_FILTER, STATUS_FILTER];

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
    filterConfig,
  };
};

export const exportPageData = {
  modelName: "state_masters",
  schema: schema,
  include: [{ module: "country_masters", moduleAs: "country" }],
  pagination: { page: 1, pageSize: 10000 },
};
